import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
import { trackCheckout } from "./CtaButton";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-16" data-mp="br2f77waqz9e">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:px-0 sm:pb-5" data-id="element-17" data-mp="bpzq95ijb6w4">
          <div className="mx-auto w-full max-w-md" data-id="element-18" data-mp="2b3qnefzur92c">
            <a href={CHECKOUT_URL} onClick={trackCheckout} className="animate-shake flex w-full items-center justify-center gap-2.5 rounded-2xl border-2 border-white/80 bg-brand px-4 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-8px_rgba(10,26,51,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/50" data-id="element-19" data-mp="2f3spgq9i24i5">
              <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-20" data-mp="1wdt34b51n3if" />
              Get it now for only $27
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}